<template>
  <v-navigation-drawer :width="240" :permanent="!$vuetify.breakpoint.sm && !$vuetify.breakpoint.xs" dark app
    class="rounded-0" v-model="$store.state.sidebar.open" :mini-variant.sync="$store.state.sidebar.mini"
    :expand-on-hover="!$vuetify.breakpoint.sm && !$vuetify.breakpoint.xs && $store.state.sidebar.expand_on_hover && !settings_menu">
    <v-card @mouseenter="handleExpandMenu(true)" @mouseleave="handleExpandMenu(false)" class="sidebar-card"
      width="240" color="#28536B">
      <div>
        <v-list style="height: 100px" v-show="!$store.state.sidebar.mini">
          <v-list-item>
            <v-list-item-content class="pt-1" style="display: flex; justify-content: center">
              <v-img transition="fade-transition" :src="require('@/assets/images/syscore_logo.svg')" contain
                style="max-width: 100%; margin-top: 14px" class="pt-0" />
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <div style="height: 100px" v-show="$store.state.sidebar.mini" class="pt-3">
          <v-img transition="fade-transition" :src="require('@/assets/images/syscore_logo_mini.svg')" contain
            height="80" width="80%" style="margin: 0 auto" class="pt-8" />
        </div>
        <v-divider class="mt-0"></v-divider>
      </div>

      <div class="sidebar-nav">
        <div style="scroll-margin-top: 100px" v-for="item in items" :key="item.title">
          <v-list v-if="item.visible" dense nav>
            <v-list-group v-if="item.visible && 'items' in item && item.items.length > 0" v-model="item.active"
              :key="item.title" :class="{ 'sidebar-group--current': isCurrentGroup(item) }" no-action>
              <v-list-item slot="activator">
                <v-list-item-icon>
                  <font-awesome-icon :icon="item.icon" />
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class=" item-title ">{{ item.title }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
  
              <router-link v-for="subItem in item.items" :key="subItem.title" :to="'/' + subItem.path">
                <v-list-item v-if="subItem.visible" ripple @click="close" class="subitem">
                  <!--<v-list-item-icon>
                    <font-awesome-icon :icon="subItem.icon" />
                  </v-list-item-icon>-->
                  <v-list-item-content class="pl-6">
                    <v-list-item-title>{{ subItem.title }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </router-link>
            </v-list-group>
  
            <router-link v-else-if="item.visible" :to="'/' + item.path">
              <v-list-item :key="item.title" link>
                <v-list-item-icon>
                  <font-awesome-icon :icon="item.icon" />
                </v-list-item-icon>
  
                <v-list-item-content>
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item-content>
                <!-- Recibos pendientes de firma del empleado -->
                <v-list-item-action v-if="item.path == my_payslips && $store.state.my_payslips_pending > 0" class="my-0">
                  <v-chip x-small color="orange" dark>{{ $store.state.my_payslips_pending }}</v-chip>
                </v-list-item-action>
              </v-list-item>
            </router-link>
          </v-list>
        </div>
      </div>

      <div class="sidebar-user">
        <div class="sidebar-user__avatar">{{ getInitials() }}</div>
        <div v-show="!$store.state.sidebar.mini" class="sidebar-user__info">
          <div class="sidebar-user__name">{{ getName() }}</div>
          <div class="sidebar-user__email">{{ getEmail() }}</div>
        </div>
        <div v-show="!$store.state.sidebar.mini" class="sidebar-user__actions">
          <v-menu v-model="settings_menu" top offset-y light :close-on-content-click="false" max-width="300" eager>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon small title="Configuración" aria-label="Configuración" v-bind="attrs" v-on="on">
                <v-icon small>mdi-cog</v-icon>
              </v-btn>
            </template>
            <v-list dense>
              <PushNotificationsItem dense />
              <v-list-item @click="$router.push('/change-password')">
                <v-list-item-icon class="mr-3">
                  <v-icon small>mdi-lock-reset</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Cambiar contraseña</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-btn icon small title="Cerrar sesión" aria-label="Cerrar sesión" @click="dialog_logout = true">
            <v-icon small>mdi-export</v-icon>
          </v-btn>
        </div>
      </div>
    </v-card>

    <DialogYesNo :open="dialog_logout" title="Confirmar" message="¿Estas seguro que quieres cerrar sesion?" @cancel="dialog_logout = false" @accept="logoutConfirm" />
  </v-navigation-drawer>
</template>

<script>
import DialogYesNo from "@/components/DialogYesNo.vue";
import PushNotificationsItem from "@/components/PushNotificationsItem.vue";
import Constant from "@/constants/sections";
import { authService } from "@/libs/ws/authService";
import GenericMixin from "@/mixins/GenericMixin.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import SettingsMixin from "@/mixins/SettingsMixin.vue";
import { myPayslipService } from "@/libs/ws/myPayslipService";
export default {
  components: { DialogYesNo, PushNotificationsItem },
  mixins: [GenericMixin, RolMixin, SettingsMixin],
  data() {
    return {
      dialog_logout: false,
      settings_menu: false,
      isExternal: null,
      my_payslips: Constant.SECTION_MY_PAYSLIPS,
      allItems: [
        {
          title: "Usuarios",
          icon: "user-tie",
          path: Constant.SECTION_USERS,
          visible: false,
        },
        {
          title: "Dashboard",
          icon: "tachometer-alt",
          path: Constant.SECTION_METRICS,
          visible: false,
        },
        {
          title: "Mis recibos",
          icon: "file-invoice",
          path: Constant.SECTION_MY_PAYSLIPS,
          visible: false,
        },
        {
          title: "Novedades",
          icon: "bullhorn",
          path: Constant.SECTION_NEWS,
          visible: false,
        },
        {
          title: "Legajos",
          icon: "user-tie",
          path: Constant.SECTION_LEGAJOS,
          visible: false,
        },
        {
          title: "Organigrama",
          icon: "sitemap",
          path: Constant.SECTION_ORG_CHART,
          visible: false,
        },
        {
          title: "Recibos de sueldo",
          icon: "file-invoice-dollar",
          path: Constant.SECTION_PAYSLIPS,
          visible: false,
        },
        {
          title: "Fichajes",
          icon: "fingerprint",
          path: Constant.SECTION_SIGNINGS,
          visible: false,
        },
        {
          title: "Administrar",
          icon: "cog",
          active: false,
          visible: false,
          items: [
            {
              title: "Carpetas",
              icon: "user-tie",
              path: Constant.SECTION_FOLDERS,
              visible: false,
            },
            {
              title: "Sucursales",
              icon: "user-tie",
              path: Constant.SECTION_SUCURSALES,
              visible: false,
            },
            {
              title: "Sectores",
              icon: "user-tie",
              path: Constant.SECTION_WORKSECTORS,
              visible: false,
            },
            {
              title: "Puestos",
              icon: "user-tie",
              path: Constant.SECTION_WORKSTATIONS,
              visible: false,
            },
            {
              title: "Tipos de puesto",
              icon: "sitemap",
              path: Constant.SECTION_ORG_CHART_NODE_TYPES,
              visible: false,
            },

            {
              title: "Colaboradores",
              icon: "user-tie",
              path: Constant.SECTION_EMPLOYEES,
              visible: false,
            },
          
            {
              title: "Roles",
              icon: "user-cog",
              path: Constant.SECTION_ROLES,
              visible: false,
            },
            {
              title: "Configuración",
              icon: "cogs",
              path: Constant.SECTION_SETTINGS,
              visible: false,
            },
          ],
        },
      ],
      items: [],
      right: null,
      expandMenu: this.$store.state.sidebar.open ? true : false,
      isMobile: false,
      show: true,
    };
  },
  mounted() {
    this.loadSideBarExternal();
    this.loadMyPayslipsPending();
  },
  watch: {
    $route() {
      this.openCurrentGroup();
    },
  },
  methods: {
    getName() {
      return localStorage.getItem("name");
    },
    getEmail() {
      return localStorage.getItem("email");
    },
    getInitials() {
      return authService.userInitials();
    },
    logoutConfirm() {
      authService.logOut();
      this.$router.push("/login");
    },
    isCurrentGroup(item) {
      return item.items.some((sub_item) => sub_item.visible && (this.$route.path + "/").startsWith("/" + sub_item.path + "/"));
    },
    // Abre el grupo de la sección actual para que su marca quede a la vista
    openCurrentGroup() {
      this.items.forEach((item) => {
        if ("items" in item && this.isCurrentGroup(item)) item.active = true;
      });
    },
    handleExpandMenu(value) {
      if (this.$store.state.sidebar.mini) {
        this.$store.commit("setOpenSidebar", {
          expand_on_hover: true,
        });
      }
    },
    close() { },
    loadMyPayslipsPending() {
      if (!(Constant.SECTION_MY_PAYSLIPS in this.roles)) return;
      myPayslipService
        .pending_count()
        .then((response) => {
          if (response.status) this.$store.commit("setMyPayslipsPending", response.result);
        })
        .catch((e) => console.log(e));
    },
    loadSideBarExternal() {
      this.items = this.getItemsAvailable();
      this.openCurrentGroup();
    },
    getItemsAvailable() {
      let itemsAvailable = [...this.allItems];
      itemsAvailable.forEach((item) => {
        if ("items" in item) {
          let any_visible = false;
          item.items.forEach((sub_item) => {
            sub_item.visible = sub_item.path in this.roles && this.roles[sub_item.path].sidebar;
            if (sub_item.visible) any_visible = true;
          });
          item.visible = any_visible;
        } else {
          item.visible = item.path in this.roles && this.roles[item.path].sidebar;
        }

        //Si el item solo es visible con stock y no es una empresa de productos, se oculta
        if (item.only_visible_with_stock != undefined && item.only_visible_with_stock && !this.isProductCompany()) {
          item.visible = false;
        }
      });
      return itemsAvailable;
    },
  },
};
</script>
